import { Box, Card, CardContent, Grid, Slider } from "@mui/material"
import { Title, useAuthenticated, useCanAccessResources } from "react-admin"
import { ActiveUsers } from "./Sections/ActiveUsers"
import { RegistrationsChart } from "./Sections/RegistrationsChart"
import TimezoneSelect from "react-timezone-select"; //TODO: find how to use hook

import { DepositsByDay, NewByGenderClid, DepositsByMonth, UsersByCity, Totals } from "./Sections";

import { useLocalStorage } from "@/src/services/useLocalStorage";



export const Dashboard = () => {

    const { isPending: isPendingB } = useAuthenticated();
    const [timezone, setTimezone] = useLocalStorage("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone);
    const { isPending: isPendingA, canAccess } = useCanAccessResources({ action: 'list', resources: ['deposit'] })
    if (isPendingA || isPendingB) return <Box>Loading...</Box>;


    return (


        <Card>
            <Title title="Dashboard" />
            <CardContent>
                <TimezoneSelect value={timezone} onChange={(value) => setTimezone(value.value)} />
                {/* <div>{timezone}-{utcOffset}---{}</div> */}
                <Grid container spacing={1}>
                    {/* <Grid size={{xs:12,sm:12,md:6}}>
                                <RetentionByClaims />
                            </Grid> */}
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <Totals timezone={timezone} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <ActiveUsers timezone={timezone} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <RegistrationsChart timezone={timezone} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <NewByGenderClid timezone={timezone} />
                    </Grid>
                    {canAccess?.['deposit'] &&
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <DepositsByDay timezone={timezone} />

                        </Grid>
                    }
                    {canAccess?.['deposit'] &&
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <DepositsByMonth timezone={timezone} />
                        </Grid>
                    }
                    <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                        <UsersByCity timezone={timezone} />
                    </Grid>

                </Grid>
                <Grid container spacing={1}>

                </Grid>

            </CardContent>
        </Card>


    )
}